export * from "./StartMenu";
export { default } from "./StartMenu";
